import React from "react";
import { Box, Alert } from "@mui/material";
import { useSkillSheetMainStepper } from "../context/SkillSheetMainStepperContext";

// localStorage の保存 / 読み込み失敗の通知
const MESSAGES = {
  save: "入力内容をこのブラウザに保存できませんでした。この画面を閉じると、入力内容が失われる可能性があります。",
  load: "保存されているデモ入力内容を読み込めませんでした。デモ入力を削除して、もう一度お試しください。",
};

export default function DemoStorageAlert() {
  const { demoStorageWarning, dismissDemoStorageWarning } =
    useSkillSheetMainStepper();

  if (!demoStorageWarning) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning" onClose={dismissDemoStorageWarning}>
        {MESSAGES[demoStorageWarning]}
      </Alert>
    </Box>
  );
}
